//import { useOktaAuth } from "@okta/okta-react";

export const fetchAPI = async (endpoint, responsetype, token = "") => {
    //const { authState, oktaAuth } = useOktaAuth();

    if (!responsetype || !endpoint) {
        return {
            show: false
        }
    }

    if (responsetype === "token") {
        if (token == "") {
            //mock 401
            return {
                show: true,
                success: false,
                serverError: true,
                statuscode: 401,
                message: "You must log in in order to get authentication token",
                endpoint: endpoint,
                responsetype: "string",
                data: token
            }
        }

        return {
            show: true,
            success: true,
            serverError: null,
            statuscode: 200,
            message: "",
            endpoint: endpoint,
            responsetype: "string",
            data: 'Bearer ' + token
        }
    }

    if (responsetype === "json") {
        try {
            const response = await fetch("https://bradycustomlockdevapi.azurewebsites.net/api/" + endpoint,{
                headers: {
                    //Authorization: 'Bearer ' + authState?.isAuthenticated ? authState.accessToken : ""
                    Authorization: 'Bearer ' + token
                }
            });

            if (response?.ok) {
                let json = await response.json();
                return {
                    show: true,
                    success: true,
                    serverError: null,
                    statuscode: response.status,
                    message: null,
                    endpoint: endpoint,
                    responsetype: responsetype,
                    data: json
                }
            } else {
                console.log(...response.headers)
                return {
                    show: true,
                    success: false,
                    serverError: true,
                    statuscode: response?.status,
                    message: !response.message ? "" : response.message,
                    endpoint: endpoint,
                    responsetype: responsetype,
                    data: null
                }
            }
        } catch (error) {
            console.log(error);
            return {
                show: true,
                success: false,
                serverError: false,
                statuscode: 0,
                message: error.message,
                endpoint: endpoint,
                responsetype: responsetype,
                data: null
            }
        }
    } else {
        try {
            let response = await fetch("https://bradycustomlockdevapi.azurewebsites.net/api/" + endpoint,{
                headers: {
                    //Authorization: 'Bearer ' + authState?.isAuthenticated ? authState.accessToken : ""
                    Authorization: 'Bearer ' + token
                }
            })

            if (response?.ok) {
                let txt = await response.text();
                return {
                    show: true,
                    success: true,
                    serverError: null,
                    statuscode: response.status,
                    message: null,
                    endpoint: endpoint,
                    responsetype: responsetype,
                    data: txt
                }
            } else {
                console.log(...response.headers)
                return {
                    show: true,
                    success: false,
                    serverError: true,
                    statuscode: response?.status,
                    message: !response.message ? "" : response.message,
                    endpoint: endpoint,
                    responsetype: responsetype,
                    data: null
                }
            }
        } catch (error) {
            console.log(error);
            return {
                show: true,
                success: false,
                serverError: false,
                statuscode: 0,
                message: error.message,
                endpoint: endpoint,
                responsetype: responsetype,
                data: null
            }
        }
    }
}